import React, { useState, useRef, useEffect } from "react"
import "./AddUniversity.scss"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  Spinner,
} from "reactstrap"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import Country from "../../../utils/Data/Country"
import * as Yup from "yup"
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { Calendar } from "primereact/calendar"
import { InputNumber } from "primereact/inputnumber"
import { useLocation, useNavigate } from "react-router-dom"
import UniversityApi from "Api/UniversityApi"
import { Toast } from "primereact/toast"
import S3UploadApi from "Api/s3Upload"
import CourseApi from "Api/CourseApi"

const AddUniversity = () => {
  document.title = "Add University"
  const navigate = useNavigate("")
  const accessToken = localStorage.getItem("accessToken")
  const universityInitialData = {
    universityName: "",
    displayName: "",
    type: "",
    yearEstablished: "",
    country: "",
    state: "",
    city: "",
    pinCode: null,
    address: "",
    campusSize: "",
    noOfStudents: null,
    noOfDepartments: "",
    noOfCourses: "",
    totalFaculty: "",
    officialWebsite: "",
    nirfRanking: "",
    indiaToday2023Ranking: "",
    timesRanking2024: null,
    email: "",
    ugcApproval: "",
    aiuAffiliation: "",
    highlights: "",
    aboutContent: "",
    logo: {
      url: "",
      alt: "",
    },
    qsRanking: "",
    cutoffs: [],
    bannerImage: {
      url: "",
      alt: "",
    },
    gallery: [],
    beddedHospital: "",
    yearlyIntake: "",
    departments: "",
    pixwikShow: { name: "No", code: "No" },
  }

  const [universityData, setUniversityData] = useState(universityInitialData)
  const toast = useRef(null)

  const [logoFile, setLogoFile] = useState(null)
  const [logoUrl, setLogoUrl] = useState("")
  const [isUploading, setIsUploading] = useState(false)

  const [errors, setErrors] = useState({})
  const handleUniverSityDataChange = (name, value) => {
    setUniversityData({ ...universityData, [name]: value })
    setErrors({ ...errors, [name]: "" })
  }

  const breadcrumbItems = [
    { label: "Pixwik", link: "#" },
    { label: "University", link: "#" },
    { label: "Add University", link: "#" },
  ]
  const typeOptions = [
    { name: "Central", code: "Central" },
    { name: "State", code: "State" },
    { name: "Private", code: "Private" },
    { name: "Deemed", code: "Deemed" },
    { name: "Autonomous", code: "Autonomous" },
    { name: "Government", code: "Government" },
  ]
  const approvalOptions = [
    { name: "Yes", code: "Yes" },
    { name: "No", code: "No" },
  ]

  const quotaOptions = [
    { name: "OC", code: "OC" },
    { name: "OBC", code: "OBC" },
    { name: "SC", code: "SC" },
    { name: "ST", code: "ST" },
  ]

  const validateUniversity = Yup.object().shape({
    universityName: Yup.string().required("University name is required"),
    displayName: Yup.string().required("Display name is required"),
    type: Yup.string()
      // .oneOf(
      //   ["central", "state", "private", "deemed", "autonomous"],
      //   "Invalid Type",
      // )
      .required("University type required"),
    // yearEstablished: Yup.number()
    //   .typeError("Established year must be a valid number")
    //   .min(1800, "Year cannot be before 1800")
    //   .max(new Date().getFullYear(), "Year cannot be in the future")
    //   .required("Established year is required"),
    country: Yup.string().required("Country is required"),
    state: Yup.string().required("State is required"),
    city: Yup.string().required("City is required"),
    pinCode: Yup.string().required("PinCode is required"),
    address: Yup.string().required("Address is required"),
    // phone: Yup.string()
    //   .matches(/^\+\d{1,3}[-\s]?\d{10}$/, "Invalid phone number")
    //   .required("Phone number is required"),
    // email: Yup.string()
    //   .email("Invalid email format")
    //   .required("Email is required"),
    // officialWebsite: Yup.string().required("officialWebsite is required"),
    // description: Yup.string().required("Description is required"),
    // nirfRanking: Yup.string().required("nirfRanking is required"),
    // indiaToday2023Ranking: Yup.string().required(
    //   "indiaToday2023Ranking is required",
    // ),
    // timesRanking2024: Yup.string().required("timesRanking2024 is required"),
    // campusSize: Yup.string().required("campusSize is required"),
    // noOfStudents: Yup.string().required("noOfStudents is required"),
    // noOfDepartments: Yup.string().required("noOfDepartments is required"),
    // noOfCourses: Yup.string().required("noOfCourses is required"),
    // totalFaculty: Yup.string().required("totalFaculty is required"),
    // ugcApproval: Yup.boolean()
    //   .oneOf([true, false], "Invalid UGC approval")
    //   .required("Choose UGC Approval"),
    // aiuAffiliation: Yup.boolean()
    //   .oneOf([true, false], "Invalid AIU Affiliation")
    //   .required("Choose AIU Affiliation"),
    highlights: Yup.string().required("highlights is required"),
    aboutContent: Yup.string().required("aboutContent is required"),
    // qsRanking: Yup.string().required("QS Ranking is required"),

    // cutoffs: Yup.array().of(
    //   Yup.object().shape({
    //     course: Yup.string().required("Course is required"),
    //     year: Yup.number().required("Year is required"),
    //     quota: Yup.string()
    //       .oneOf(["OC", "OBC", "SC", "ST"], "Invalid quota")
    //       .required("Quota is required"),
    //     rounds: Yup.object().shape({
    //       round1: Yup.string(),
    //       round2: Yup.string(),
    //       mopUpRound: Yup.string(),
    //       strayVacancy: Yup.string(),
    //     }),
    //   }),
    // ),
    // beddedHospital: Yup.string(),
    // yearlyIntake: Yup.string(),
    // departments: Yup.string(),
  })

  const [loading, setLoading] = useState(false)

  const [currentCutoff, setCurrentCutoff] = useState({
    course: "",
    year: "",
    quota: "",
    rounds: {
      round1: "TBA",
      round2: "TBA",
      mopUpRound: "TBA",
      strayVacancy: "TBA",
    },
  })

  const [galleryFiles, setGalleryFiles] = useState([])
  const [galleryUrls, setGalleryUrls] = useState([])
  const [galleryAltTexts, setGalleryAltTexts] = useState([])
  const [isUploadingGallery, setIsUploadingGallery] = useState(false)
  const [bannerFile, setBannerFile] = useState(null)
  const [bannerUrl, setBannerUrl] = useState("")
  const [isUploadingBanner, setIsUploadingBanner] = useState(false)

  const [courseData, setCourseData] = useState([])

  const getCourseList = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
    CourseApi.getAllCourse(config)
      .then(res => {
        if (res.data.status) {
          const formattedCourses = res.data.Course.map(course => ({
            name: course.courseName,
            code: course._id,
            originalCourse: course,
          }))
          setCourseData(formattedCourses)
        }
      })
      .catch(err => {
        console.error("Error fetching courses:", err)
        setCourseData([])
      })
  }

  useEffect(() => {
    getCourseList()
  }, [accessToken])

  const handleLogoChange = e => {
    if (e.target.files && e.target.files[0]) {
      setLogoFile(e.target.files[0])
      setLogoUrl("")
    }
  }

  const deleteImage = async imageUrl => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }

      await S3UploadApi.deleteImage({ fileUrl: imageUrl }, config)
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Image deleted successfully",
        life: 3000,
      })
      return true
    } catch (error) {
      console.error("Error deleting image:", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to delete image",
        life: 3000,
      })
      return false
    }
  }

  const handleLogoDelete = async () => {
    if (logoUrl) {
      const success = await deleteImage(logoUrl)
      if (success) {
        setLogoUrl("")
        handleUniverSityDataChange("logo", "")
      }
    }
  }

  const handleBannerDelete = async () => {
    if (bannerUrl) {
      const success = await deleteImage(bannerUrl)
      if (success) {
        setBannerUrl("")
        handleUniverSityDataChange("bannerImage", "")
      }
    }
  }

  const removeGalleryImage = async indexToRemove => {
    const imageUrl = galleryUrls[indexToRemove]
    const success = await deleteImage(imageUrl)
    if (success) {
      setGalleryUrls(galleryUrls.filter((_, index) => index !== indexToRemove))
      setGalleryAltTexts(
        galleryAltTexts.filter((_, index) => index !== indexToRemove),
      )

      // Update the gallery data in universityData
      const updatedGallery = galleryUrls
        .filter((_, index) => index !== indexToRemove)
        .map((url, i) => ({
          url,
          alt: galleryAltTexts[i] || "",
        }))
      handleUniverSityDataChange("gallery", updatedGallery)
    }
  }

  const removeSelectedFile = indexToRemove => {
    setGalleryFiles(galleryFiles.filter((_, index) => index !== indexToRemove))
  }

  const uploadLogo = async () => {
    if (!logoFile) return null

    setIsUploading(true)
    try {
      const formData = new FormData()
      formData.append("image", logoFile)

      const response = await S3UploadApi.uploadImage(formData)
      const newLogoUrl = response.data.imageUrl

      setLogoUrl(newLogoUrl)
      handleUniverSityDataChange("logo", newLogoUrl)
      setLogoFile(null)
      setIsUploading(false)
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Logo uploaded successfully",
        life: 3000,
      })
      return newLogoUrl
    } catch (error) {
      console.error("Error uploading logo:", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Error uploading logo",
        life: 3000,
      })
      setIsUploading(false)
      return null
    }
  }

  const handleBannerChange = e => {
    if (e.target.files && e.target.files[0]) {
      setBannerFile(e.target.files[0])
      setBannerUrl("")
    }
  }

  const uploadBanner = async () => {
    if (!bannerFile) return null

    setIsUploadingBanner(true)
    try {
      const formData = new FormData()
      formData.append("image", bannerFile)

      const response = await S3UploadApi.uploadImage(formData)
      const newBannerUrl = response.data.imageUrl

      setBannerUrl(newBannerUrl)
      handleUniverSityDataChange("bannerImage", newBannerUrl)
      setBannerFile(null)
      setIsUploadingBanner(false)
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Banner uploaded successfully",
        life: 3000,
      })
      return newBannerUrl
    } catch (error) {
      console.error("Error uploading banner:", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Error uploading banner",
        life: 3000,
      })
      setIsUploadingBanner(false)
      return null
    }
  }

  const handleGalleryChange = e => {
    if (e.target.files) {
      setGalleryFiles([...galleryFiles, ...Array.from(e.target.files)])
    }
  }

  const uploadGalleryImages = async () => {
    if (galleryFiles.length === 0) return

    setIsUploadingGallery(true)
    try {
      const uploadPromises = galleryFiles.map(async file => {
        const formData = new FormData()
        formData.append("image", file)

        const response = await S3UploadApi.uploadImage(formData)
        return response.data.imageUrl
      })

      const newUrls = await Promise.all(uploadPromises)
      const newAltTexts = newUrls.map(() => "") // Initialize empty alt texts for new images

      setGalleryUrls([...galleryUrls, ...newUrls])
      setGalleryAltTexts([...galleryAltTexts, ...newAltTexts])
      setGalleryFiles([])
      setIsUploadingGallery(false)
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Gallery images uploaded successfully",
        life: 3000,
      })
    } catch (error) {
      console.error("Error uploading gallery images:", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Error uploading gallery images",
        life: 3000,
      })
      setIsUploadingGallery(false)
    }
  }

  const handleGalleryAltTextChange = (index, value) => {
    const newAltTexts = [...galleryAltTexts]
    newAltTexts[index] = value
    setGalleryAltTexts(newAltTexts)

    // Update the gallery data in universityData
    const updatedGallery = galleryUrls.map((url, i) => ({
      url,
      alt: newAltTexts[i] || "",
    }))
    handleUniverSityDataChange("gallery", updatedGallery)
  }

  // const handleAddReview = () => {
  //   if (!currentReview.name || !currentReview.review) {
  //     toast.current.show({
  //       severity: "error",
  //       summary: "Error",
  //       detail: "Both name and review are required",
  //       life: 3000,
  //     })
  //     return
  //   }

  //   const updatedReviews = [...universityData.reviews, currentReview]
  //   handleUniverSityDataChange("reviews", updatedReviews)
  //   setCurrentReview({ name: "", review: "" })

  //   toast.current.show({
  //     severity: "success",
  //     summary: "Success",
  //     detail: "Review added successfully",
  //     life: 3000,
  //   })
  // }

  // const handleRemoveReview = index => {
  //   const updatedReviews = universityData.reviews.filter((_, i) => i !== index)
  //   handleUniverSityDataChange("reviews", updatedReviews)

  //   toast.current.show({
  //     severity: "success",
  //     summary: "Success",
  //     detail: "Review removed successfully",
  //     life: 3000,
  //   })
  // }

  const handleAddCutoff = () => {
    if (!currentCutoff.course || !currentCutoff.year || !currentCutoff.quota) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Course, Year and Quota are required",
        life: 3000,
      })
      return
    }

    const newCutoff = {
      course: currentCutoff.course.code,
      year: currentCutoff.year,
      quota: currentCutoff.quota.code,
      rounds: currentCutoff.rounds,
    }

    const updatedCutoffs = [...universityData.cutoffs, newCutoff]
    handleUniverSityDataChange("cutoffs", updatedCutoffs)
    setCurrentCutoff({
      course: "",
      year: "",
      quota: "",
      rounds: {
        round1: "TBA",
        round2: "TBA",
        mopUpRound: "TBA",
        strayVacancy: "TBA",
      },
    })

    toast.current.show({
      severity: "success",
      summary: "Success",
      detail: "Cutoff added successfully",
      life: 3000,
    })
  }

  const handleRemoveCutoff = index => {
    const updatedCutoffs = universityData.cutoffs.filter((_, i) => i !== index)
    handleUniverSityDataChange("cutoffs", updatedCutoffs)

    toast.current.show({
      severity: "success",
      summary: "Success",
      detail: "Cutoff removed successfully",
      life: 3000,
    })
  }

  const addUniversity = async () => {
    try {
      setLoading(true)
      // Upload logo first if needed
      if (logoFile && !logoUrl) {
        const uploadedLogoUrl = await uploadLogo()
        if (!uploadedLogoUrl) {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "Failed to upload logo",
            life: 3000,
          })
          return
        }
      }

      // Upload banner if needed
      if (bannerFile && !bannerUrl) {
        const uploadedBannerUrl = await uploadBanner()
        if (!uploadedBannerUrl) {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "Failed to upload banner",
            life: 3000,
          })
          return
        }
      }

      const payload = {
        ...universityData,
        gallery: galleryUrls.map((url, i) => ({
          url,
          alt: galleryAltTexts[i] || "",
        })),
        country: universityData?.country?.name || "",
        state: universityData?.state || "",
        city: universityData?.city || "",
        type: universityData?.type?.name?.toLowerCase() || "",
        aiuAffiliation:
          universityData?.aiuAffiliation?.name === "Yes" ? true : false,
        ugcApproval: universityData?.ugcApproval?.name === "Yes" ? true : false,
        pixwikShow: universityData?.pixwikShow?.name === "Yes" ? true : false,
      }

      console.log("Submitting payload:", payload)

      validateUniversity
        .validate(payload, { abortEarly: false })
        .then(() => {
          const config = {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }

          UniversityApi.addUniversity(payload, config)
            .then(response => {
              if (response.data.status) {
                setLoading(false)

                setTimeout(() => {
                  navigate("/universitylist")
                }, 1000)

                toast.current.show({
                  severity: "success",
                  summary: "Success",
                  detail: "University added successfully!",
                  life: 3000,
                })
              }
            })
            .catch(error => {
              setLoading(false)
              const errorMessage =
                error.response &&
                error.response.data &&
                error.response.data.message
                  ? error.response.data.message
                  : "Unable to add university"

              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: errorMessage,
                life: 3000,
              })
            })
        })
        .catch(err => {
          setLoading(false)

          const validationErrors = {}
          err.inner.forEach(error => {
            validationErrors[error.path] = error.message
          })
          setErrors(validationErrors)
        })
    } catch (error) {
      console.error("Unexpected error in addUniversity:", error)
      setLoading(false)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "An unexpected error occurred",
        life: 3000,
      })
    }
  }

  return (
    <div className="add-university">
      <Toast ref={toast} />
      <Row>
        <Col xs="12">
          <div className="university-list-header d-flex  align-items-center justify-content-between">
            <CustomBreadCrumb
              data={breadcrumbItems}
              pageTitle="Add University"
            />
          </div>

          <Card className="mt-4 ">
            <CardBody>
              <div className="university-add-form ">
                <div className="university-add-inp">
                  <label htmlFor="universityName" className="label">
                    University Name
                    <small className="text-danger"> *</small>
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="universityName"
                      value={universityData.universityName}
                      onChange={e =>
                        handleUniverSityDataChange(
                          "universityName",
                          e.target.value,
                        )
                      }
                      placeholder="Enter University Name"
                      className="inp-field-box"
                    />
                    {errors.universityName && (
                      <small className="error">{errors.universityName}</small>
                    )}
                  </div>
                </div>
                <div className="university-add-inp">
                  <label htmlFor="displayName" className="label">
                    Display Name
                    <small className="text-danger"> *</small>
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="displayName"
                      value={universityData.displayName}
                      onChange={e =>
                        handleUniverSityDataChange(
                          "displayName",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Display Name"
                      className="inp-field-box"
                    />
                    {errors.displayName && (
                      <small className="error">{errors.displayName}</small>
                    )}
                  </div>
                </div>
                <div className="university-add-inp">
                  <label htmlFor="type" className="label">
                    Type
                    <small className="text-danger"> *</small>
                  </label>

                  <div className="inp-err">
                    <Dropdown
                      value={universityData.type}
                      onChange={e =>
                        handleUniverSityDataChange("type", e.value)
                      }
                      options={typeOptions}
                      optionLabel="name"
                      placeholder="Select Type"
                      filter
                      className="inp-field-box"
                    />

                    {errors.type && (
                      <small className="error">{errors.type}</small>
                    )}
                  </div>
                </div>
                <div className="university-add-inp">
                  <label htmlFor="yearEstablished" className="label">
                    Year Established
                  </label>
                  <div className="inp-err">
                    <Calendar
                      id="yearEstablished"
                      value={
                        universityData.yearEstablished
                          ? new Date(universityData.yearEstablished, 0)
                          : null
                      }
                      onChange={e => {
                        const selectedYear = e.value
                          ? new Date(e.value).getFullYear()
                          : null
                        handleUniverSityDataChange(
                          "yearEstablished",
                          selectedYear,
                        )
                      }}
                      view="year"
                      dateFormat="yy"
                      placeholder="Select  Year Established"
                      className="inp-field-box"
                    />

                    {errors.establishedYear && (
                      <small className="error">{errors.establishedYear}</small>
                    )}
                  </div>
                </div>

                <div className="university-add-inp">
                  <label htmlFor="country" className="label">
                    Country
                    <small className="text-danger"> *</small>
                  </label>
                  <div className="inp-err">
                    <Dropdown
                      id="country"
                      value={universityData.country}
                      onChange={e =>
                        handleUniverSityDataChange("country", e.value)
                      }
                      options={Country}
                      optionLabel="name"
                      placeholder="Select Country"
                      filter
                      className="inp-field-box"
                    />

                    {errors.country && (
                      <small className="error">{errors.country}</small>
                    )}
                  </div>
                </div>

                <div className="university-add-inp">
                  <label htmlFor="state" className="label">
                    State
                    <small className="text-danger"> *</small>
                  </label>

                  <div className="inp-err">
                    <InputText
                      id="state"
                      value={universityData.state}
                      onChange={e =>
                        handleUniverSityDataChange("state", e.target.value)
                      }
                      placeholder="Enter State"
                      className="inp-field-box"
                    />
                    {errors.state && (
                      <small className="error">{errors.state}</small>
                    )}
                  </div>
                </div>

                <div className="university-add-inp">
                  <label htmlFor="username" className="label">
                    City
                    <small className="text-danger"> *</small>
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="city"
                      placeholder="Enter City"
                      value={universityData.city}
                      onChange={e =>
                        handleUniverSityDataChange("city", e.target.value)
                      }
                      className="inp-field-box"
                    />
                    {errors.city && (
                      <small className="error">{errors.city}</small>
                    )}
                  </div>
                </div>

                <div className="university-add-inp">
                  <label htmlFor="pinCode" className="label">
                    Pin Code
                    <small className="text-danger"> *</small>
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="pinCode"
                      value={universityData.pinCode}
                      onChange={e =>
                        handleUniverSityDataChange("pinCode", e.target.value)
                      }
                      placeholder="Enter Pin Code"
                      className="inp-field-box"
                    />
                    {errors.pinCode && (
                      <small className="error">{errors.pinCode}</small>
                    )}
                  </div>
                </div>

                <div className="university-add-inp">
                  <label htmlFor="address" className="label">
                    Address
                    <small className="text-danger"> *</small>
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="address"
                      value={universityData.address}
                      onChange={e =>
                        handleUniverSityDataChange("address", e.target.value)
                      }
                      placeholder="Enter Address"
                      className="inp-field-box"
                    />

                    {errors.address && (
                      <small className="error">{errors.address}</small>
                    )}
                  </div>
                </div>
                {/* 
                <div className="university-add-inp">
                  <label htmlFor="phoneNumber" className="label">
                    Phone
                  </label>

                  <div className="inp-err">
                    <div className="p-inputgroup  phone-number ">
                      <Dropdown
                        id="phone"
                        value={universityData.country}
                        options={Country}
                        optionLabel="dialCode"
                        placeholder="+XX"
                        filter
                      />
                      <InputNumber
                        id="phoneNumber"
                        value={universityData.phone}
                        onChange={e =>
                          handleUniverSityDataChange("phone", e.value)
                        }
                        useGrouping={false}
                        placeholder="Enter Phone Number"
                      />
                    </div>

                    {errors.phone && (
                      <small className="error">{errors.phone}</small>
                    )}
                  </div>
                </div> */}
                <div className="university-add-inp">
                  <label htmlFor="email" className="label">
                    Email
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="email"
                      value={universityData.email}
                      onChange={e =>
                        handleUniverSityDataChange("email", e.target.value)
                      }
                      placeholder="Enter Email"
                      className="inp-field-box"
                    />
                    {errors.email && (
                      <small className="error">{errors.email}</small>
                    )}
                  </div>
                </div>
                <div className="university-add-inp">
                  <label htmlFor="officialWebsite" className="label">
                    Official Website
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="officialWebsite"
                      value={universityData.officialWebsite}
                      onChange={e =>
                        handleUniverSityDataChange(
                          "officialWebsite",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Official Website"
                      className="inp-field-box"
                    />
                    {errors.officialWebsite && (
                      <small className="error">{errors.officialWebsite}</small>
                    )}
                  </div>
                </div>
                <div className="university-add-inp">
                  <label htmlFor="campusSize" className="label">
                    Campus Size
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="campusSize"
                      value={universityData.campusSize}
                      onChange={e =>
                        handleUniverSityDataChange("campusSize", e.target.value)
                      }
                      placeholder="Enter CampusSize"
                      className="inp-field-box"
                    />
                    {errors.campusSize && (
                      <small className="error">{errors.campusSize}</small>
                    )}
                  </div>
                </div>

                <div className="university-add-inp">
                  <label htmlFor="noOfStudents" className="label">
                    No Of Students
                  </label>
                  <div className="inp-err">
                    <InputNumber
                      id="noOfStudents"
                      value={universityData.noOfStudents}
                      onChange={e =>
                        handleUniverSityDataChange("noOfStudents", e.value)
                      }
                      placeholder="Enter No Of Students"
                      className="inp-field-box"
                    />
                    {errors.noOfStudents && (
                      <small className="error">{errors.noOfStudents}</small>
                    )}
                  </div>
                </div>

                <div className="university-add-inp">
                  <label htmlFor="noOfDepartments" className="label">
                    No Of Departments
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="noOfDepartments"
                      value={universityData.noOfDepartments}
                      onChange={e =>
                        handleUniverSityDataChange(
                          "noOfDepartments",
                          e.target.value,
                        )
                      }
                      placeholder="Enter No Of Departments"
                      className="inp-field-box"
                    />
                    {errors.noOfDepartments && (
                      <small className="error">{errors.noOfDepartments}</small>
                    )}
                  </div>
                </div>
                <div className="university-add-inp">
                  <label htmlFor="noOfCourses" className="label">
                    No Of Courses
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="noOfCourses"
                      value={universityData.noOfCourses}
                      onChange={e =>
                        handleUniverSityDataChange(
                          "noOfCourses",
                          e.target.value,
                        )
                      }
                      placeholder="Enter No Of Courses"
                      className="inp-field-box"
                    />
                    {errors.noOfCourses && (
                      <small className="error">{errors.noOfCourses}</small>
                    )}
                  </div>
                </div>
                <div className="university-add-inp">
                  <label htmlFor="totalFaculty" className="label">
                    Total Faculty
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="totalFaculty"
                      value={universityData.totalFaculty}
                      onChange={e =>
                        handleUniverSityDataChange(
                          "totalFaculty",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Total Faculty"
                      className="inp-field-box"
                    />
                    {errors.totalFaculty && (
                      <small className="error">{errors.totalFaculty}</small>
                    )}
                  </div>
                </div>
                <div className="university-add-inp">
                  <label htmlFor="nirfRanking" className="label">
                    NIRF Ranking
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="nirfRanking"
                      value={universityData.nirfRanking}
                      onChange={e =>
                        handleUniverSityDataChange(
                          "nirfRanking",
                          e.target.value,
                        )
                      }
                      placeholder="Enter NIRF Ranking"
                      className="inp-field-box"
                    />
                    {errors.nirfRanking && (
                      <small className="error">{errors.nirfRanking}</small>
                    )}
                  </div>
                </div>

                <div className="university-add-inp">
                  <label htmlFor="indiaToday2023Ranking" className="label">
                    India Today 2023 Ranking
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="indiaToday2023Ranking"
                      value={universityData.indiaToday2023Ranking}
                      onChange={e =>
                        handleUniverSityDataChange(
                          "indiaToday2023Ranking",
                          e.target.value,
                        )
                      }
                      placeholder="Enter India Today 2023 Ranking"
                      className="inp-field-box"
                    />
                    {errors.indiaToday2023Ranking && (
                      <small className="error">
                        {errors.indiaToday2023Ranking}
                      </small>
                    )}
                  </div>
                </div>
                <div className="university-add-inp">
                  <label htmlFor="timesRanking2024" className="label">
                    Times Ranking 2024
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="timesRanking2024"
                      value={universityData.timesRanking2024}
                      onChange={e =>
                        handleUniverSityDataChange(
                          "timesRanking2024",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Times Ranking 2024"
                      className="inp-field-box"
                    />
                    {errors.timesRanking2024 && (
                      <small className="error">{errors.timesRanking2024}</small>
                    )}
                  </div>
                </div>
                <div className="university-add-inp">
                  <label htmlFor="qsRanking" className="label">
                    QS Ranking
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="qsRanking"
                      value={universityData.qsRanking}
                      onChange={e =>
                        handleUniverSityDataChange("qsRanking", e.target.value)
                      }
                      placeholder="Enter QS Ranking"
                      className="inp-field-box"
                    />
                    {errors.qsRanking && (
                      <small className="error">{errors.qsRanking}</small>
                    )}
                  </div>
                </div>
                <div className="university-add-inp">
                  <label htmlFor="beddedHospital">Bedded Hospital</label>
                  <div className="inp-err">
                    <InputText
                      id="beddedHospital"
                      value={universityData.beddedHospital}
                      onChange={e =>
                        handleUniverSityDataChange(
                          "beddedHospital",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Bedded Hospital"
                      className="inp-field-box"
                    />
                  </div>
                </div>
                <div className="university-add-inp">
                  <label htmlFor="yearlyIntake">Yearly Intake</label>
                  <div className="inp-err">
                    <InputText
                      id="yearlyIntake"
                      value={universityData.yearlyIntake}
                      onChange={e =>
                        handleUniverSityDataChange(
                          "yearlyIntake",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Yearly Intake"
                      className="inp-field-box"
                    />
                  </div>
                </div>
                {/* <div className="university-add-inp">
                  <label htmlFor="departments">Departments</label>
                  <div className="inp-err">
                    <InputText
                      id="departments"
                      value={universityData.departments}
                      onChange={e =>
                        handleUniverSityDataChange(
                          "departments",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Departments"
                      className="inp-field-box"
                    />
                  </div>
                </div> */}

                {/* <div className="university-add-inp">
                  <label htmlFor="description" className="label">
                    Description
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="description"
                      value={universityData.description}
                      onChange={e =>
                        handleUniverSityDataChange(
                          "description",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Description"
                      className="inp-field-box"
                    />
                    {errors.description && (
                      <small className="error">{errors.description}</small>
                    )}
                  </div>
                </div> */}
                <div className="university-add-inp">
                  <label htmlFor="ugcApproval" className="label">
                    UGC Approval
                  </label>
                  <div className="inp-err ">
                    <Dropdown
                      value={universityData.ugcApproval}
                      onChange={e =>
                        handleUniverSityDataChange("ugcApproval", e.value)
                      }
                      options={approvalOptions}
                      optionLabel="name"
                      placeholder="Select UGC Affiliation"
                      className="inp-field-box"
                    />
                    {errors.ugcApproval && (
                      <small className="error">{errors.ugcApproval}</small>
                    )}
                  </div>
                </div>
                <div className="university-add-inp">
                  <label htmlFor="aiuAffiliation" className="label">
                    AIU Affiliation
                  </label>
                  <div className="inp-err">
                    <Dropdown
                      value={universityData.aiuAffiliation}
                      onChange={e =>
                        handleUniverSityDataChange("aiuAffiliation", e.value)
                      }
                      options={approvalOptions}
                      optionLabel="name"
                      placeholder="Select AIU Affiliation"
                      className="inp-field-box"
                    />
                    {errors.aiuAffiliation && (
                      <small className="error">{errors.aiuAffiliation}</small>
                    )}
                  </div>
                </div>

                <div className="university-add-inp">
                  <label htmlFor="pixwikShow" className="label">
                    Pixwik Show
                  </label>
                  <div className="inp-err">
                    <Dropdown
                      value={universityData.pixwikShow}
                      onChange={e =>
                        handleUniverSityDataChange("pixwikShow", e.value)
                      }
                      options={approvalOptions}
                      optionLabel="name"
                      placeholder="Select Pixwik Show"
                      className="inp-field-box"
                    />
                  </div>
                </div>

                <div className="university-add-inp">
                  <label htmlFor="highlights" className="label">
                    Highlights
                    <small className="text-danger"> *</small>
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="highlights"
                      value={universityData.highlights}
                      onChange={e =>
                        handleUniverSityDataChange("highlights", e.target.value)
                      }
                      placeholder="Enter Highlights"
                      className="inp-field-box"
                    />
                    {errors.highlights && (
                      <small className="error">{errors.highlights}</small>
                    )}
                  </div>
                </div>
                <div className="university-add-inp">
                  <label htmlFor="aboutContent" className="label">
                    About Content
                    <small className="text-danger"> *</small>
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="aboutContent"
                      value={universityData.aboutContent}
                      onChange={e =>
                        handleUniverSityDataChange(
                          "aboutContent",
                          e.target.value,
                        )
                      }
                      placeholder="Enter About Content"
                      className="inp-field-box"
                    />
                    {errors.aboutContent && (
                      <small className="error">{errors.aboutContent}</small>
                    )}
                  </div>
                </div>
                {/* <div className="university-add-inp">
                  <label>Reviews</label>
                  <div className="review-section">
                    <div className="review-input-form">
                      <div className="mb-2">
                        <label htmlFor="reviewerName">Reviewer Name</label>
                        <div className="inp-err">
                          <InputText
                            id="reviewerName"
                            value={currentReview.name}
                            onChange={e =>
                              setCurrentReview({
                                ...currentReview,
                                name: e.target.value,
                              })
                            }
                            placeholder="Enter Reviewer Name"
                          />
                        </div>
                      </div>

                      <div className="mb-2">
                        <label htmlFor="reviewText">Review</label>
                        <div className="inp-err">
                          <InputText
                            id="reviewText"
                            value={currentReview.review}
                            onChange={e =>
                              setCurrentReview({
                                ...currentReview,
                                review: e.target.value,
                              })
                            }
                            placeholder="Enter Review"
                          />
                        </div>
                      </div>

                      <Button
                        type="button"
                        color="primary"
                        size="sm"
                        className="mt-2"
                        onClick={handleAddReview}
                      >
                        Add Review
                      </Button>
                    </div>

                    {universityData.reviews.length > 0 && (
                      <div className="review-list mt-3">
                        <h6>Added Reviews:</h6>
                        {universityData.reviews.map((review, index) => (
                          <div
                            key={index}
                            className="review-item p-2 border rounded mb-2"
                          >
                            <div className="d-flex justify-content-between align-items-start">
                              <div>
                                <strong>{review.name}</strong>
                                <p className="mb-0">{review.review}</p>
                              </div>
                              <Button
                                type="button"
                                color="danger"
                                size="sm"
                                onClick={() => handleRemoveReview(index)}
                              >
                                Remove
                              </Button>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div> */}

                {/* <div className="university-add-inp">
                  <label>Cutoffs</label>
                  <div className="cutoff-section">
                    <div className="cutoff-input-form">
                      <div className="mb-2">
                        <label htmlFor="course">Course</label>
                        <div className="inp-err">
                          <Dropdown
                            id="course"
                            value={currentCutoff.course}
                            onChange={e =>
                              setCurrentCutoff({
                                ...currentCutoff,
                                course: e.value,
                              })
                            }
                            options={courseData}
                            optionLabel="name"
                            placeholder="Select Course"
                            filter
                          />
                        </div>
                      </div>

                      <div className="mb-2">
                        <label htmlFor="year">Year</label>
                        <div className="inp-err">
                          <Calendar
                            id="year"
                            value={
                              currentCutoff.year
                                ? new Date(currentCutoff.year, 0)
                                : null
                            }
                            onChange={e => {
                              const selectedYear = e.value
                                ? new Date(e.value).getFullYear()
                                : null
                              setCurrentCutoff({
                                ...currentCutoff,
                                year: selectedYear,
                              })
                            }}
                            view="year"
                            dateFormat="yy"
                            placeholder="Select Year"
                            showIcon
                          />
                        </div>
                      </div>

                      <div className="mb-2">
                        <label htmlFor="quota">Quota</label>
                        <div className="inp-err">
                          <Dropdown
                            id="quota"
                            value={currentCutoff.quota}
                            onChange={e =>
                              setCurrentCutoff({
                                ...currentCutoff,
                                quota: e.value,
                              })
                            }
                            options={quotaOptions}
                            optionLabel="name"
                            placeholder="Select Quota"
                          />
                        </div>
                      </div>

                      <div className="rounds-grid">
                        <div>
                          <label htmlFor="round1">Round 1</label>
                          <div className="inp-err">
                            <InputText
                              id="round1"
                              value={currentCutoff.rounds.round1}
                              onChange={e =>
                                setCurrentCutoff({
                                  ...currentCutoff,
                                  rounds: {
                                    ...currentCutoff.rounds,
                                    round1: e.target.value,
                                  },
                                })
                              }
                              placeholder="Round 1 Cutoff"
                            />
                          </div>
                        </div>

                        <div>
                          <label htmlFor="round2">Round 2</label>
                          <div className="inp-err">
                            <InputText
                              id="round2"
                              value={currentCutoff.rounds.round2}
                              onChange={e =>
                                setCurrentCutoff({
                                  ...currentCutoff,
                                  rounds: {
                                    ...currentCutoff.rounds,
                                    round2: e.target.value,
                                  },
                                })
                              }
                              placeholder="Round 2 Cutoff"
                            />
                          </div>
                        </div>

                        <div>
                          <label htmlFor="mopUpRound">Mop-Up Round</label>
                          <div className="inp-err">
                            <InputText
                              id="mopUpRound"
                              value={currentCutoff.rounds.mopUpRound}
                              onChange={e =>
                                setCurrentCutoff({
                                  ...currentCutoff,
                                  rounds: {
                                    ...currentCutoff.rounds,
                                    mopUpRound: e.target.value,
                                  },
                                })
                              }
                              placeholder="Mop-Up Round Cutoff"
                            />
                          </div>
                        </div>

                        <div>
                          <label htmlFor="strayVacancy">Stray Vacancy</label>
                          <div className="inp-err">
                            <InputText
                              id="strayVacancy"
                              value={currentCutoff.rounds.strayVacancy}
                              onChange={e =>
                                setCurrentCutoff({
                                  ...currentCutoff,
                                  rounds: {
                                    ...currentCutoff.rounds,
                                    strayVacancy: e.target.value,
                                  },
                                })
                              }
                              placeholder="Stray Vacancy Cutoff"
                            />
                          </div>
                        </div>
                      </div>

                      <Button
                        type="button"
                        color="primary"
                        size="sm"
                        className="mt-2"
                        onClick={handleAddCutoff}
                      >
                        Add Cutoff
                      </Button>
                    </div>

                    
                    {universityData.cutoffs.length > 0 && (
                      <div className="cutoff-list mt-3">
                        <h6>Added Cutoffs:</h6>
                        {universityData.cutoffs.map((cutoff, index) => {
                          const courseName =
                            courseData.find(c => c.code === cutoff.course)
                              ?.name || "Unknown Course"

                          return (
                            <div
                              key={index}
                              className="cutoff-item p-2 border rounded mb-2"
                            >
                              <div className="d-flex justify-content-between align-items-start">
                                <div>
                                  <strong>Course: {courseName}</strong>
                                  <p className="mb-0">Year: {cutoff.year}</p>
                                  <p className="mb-0">Quota: {cutoff.quota}</p>
                                  <div className="rounds-values">
                                    <small>
                                      Round 1: {cutoff.rounds.round1}
                                    </small>
                                    <small className="ms-2">
                                      Round 2: {cutoff.rounds.round2}
                                    </small>
                                    <small className="ms-2">
                                      Mop-Up: {cutoff.rounds.mopUpRound}
                                    </small>
                                    <small className="ms-2">
                                      Stray: {cutoff.rounds.strayVacancy}
                                    </small>
                                  </div>
                                </div>
                                <Button
                                  type="button"
                                  color="danger"
                                  size="sm"
                                  onClick={() => handleRemoveCutoff(index)}
                                >
                                  Remove
                                </Button>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    )}
                  </div>
                </div> */}
                <div className="university-add-inp">
                  <label htmlFor="logo">
                    Logo
                    <small className="text-danger"> *</small>
                  </label>
                  <div className="inp-err">
                    {logoUrl && (
                      <div className="mb-2 position-relative">
                        <img
                          src={logoUrl}
                          alt={universityData.logo?.alt || "University Logo"}
                          style={{
                            width: "100px",
                            height: "auto",
                            objectFit: "contain",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            padding: "2px",
                          }}
                        />
                        <Button
                          type="button"
                          color="danger"
                          size="sm"
                          className="position-absolute top-0 end-0"
                          style={{ margin: "2px" }}
                          onClick={handleLogoDelete}
                        >
                          ×
                        </Button>
                      </div>
                    )}
                    {logoFile && (
                      <div className="mb-2">
                        <small>Selected file: {logoFile.name}</small>
                      </div>
                    )}
                    <div className="d-flex align-items-center gap-2">
                      <input
                        type="file"
                        name="logo"
                        id="logo"
                        accept="image/*"
                        onChange={handleLogoChange}
                      />
                      {logoFile && !isUploading && !logoUrl && (
                        <Button
                          type="button"
                          color="primary"
                          size="sm"
                          className="waves-effect waves-light"
                          onClick={() => uploadLogo()}
                        >
                          Upload
                        </Button>
                      )}
                    </div>
                    {isUploading && (
                      <small className="d-block mt-1">
                        <Spinner size="sm" /> Uploading logo...
                      </small>
                    )}
                    {!isUploading && logoUrl && (
                      <>
                        <small className="d-block mt-1 text-success">
                          Logo uploaded successfully!
                        </small>
                        <div className="mb-2">
                          <label htmlFor="logoAltText">Logo Alt Text</label>
                          <InputText
                            id="logoAltText"
                            name="logoAltText"
                            className="w-100"
                            placeholder="Enter descriptive text for the logo"
                            value={universityData.logo?.alt || ""}
                            onChange={e => {
                              // Update the entire logo object in universityData
                              setUniversityData({
                                ...universityData,
                                logo: {
                                  url: logoUrl,
                                  alt: e.target.value,
                                },
                              })
                            }}
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>

                <div className="university-add-inp">
                  <label htmlFor="banner">Banner Image</label>
                  <div className="inp-err">
                    {bannerUrl && (
                      <div className="mb-2 position-relative">
                        <img
                          src={bannerUrl}
                          alt={
                            universityData.bannerImage?.alt ||
                            "University Banner"
                          }
                          style={{
                            width: "100%",
                            height: "200px",
                            objectFit: "cover",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                          }}
                        />
                        <Button
                          type="button"
                          color="danger"
                          size="sm"
                          className="position-absolute top-0 end-0"
                          style={{ margin: "2px" }}
                          onClick={handleBannerDelete}
                        >
                          ×
                        </Button>
                      </div>
                    )}
                    {bannerFile && (
                      <div className="mb-2">
                        <small>Selected file: {bannerFile.name}</small>
                      </div>
                    )}
                    <div className="d-flex align-items-center gap-2">
                      <input
                        type="file"
                        name="banner"
                        id="banner"
                        accept="image/*"
                        onChange={handleBannerChange}
                      />
                      {bannerFile && !isUploadingBanner && !bannerUrl && (
                        <Button
                          type="button"
                          color="primary"
                          size="sm"
                          className="waves-effect waves-light"
                          onClick={() => uploadBanner()}
                        >
                          Upload
                        </Button>
                      )}
                    </div>
                    {isUploadingBanner && (
                      <small className="d-block mt-1">
                        <Spinner size="sm" /> Uploading banner...
                      </small>
                    )}
                    {!isUploadingBanner && bannerUrl && (
                      <>
                        <small className="d-block mt-1 text-success">
                          Banner uploaded successfully!
                        </small>
                        <div className="mb-2">
                          <label htmlFor="bannerAltText">Banner Alt Text</label>
                          <InputText
                            id="bannerAltText"
                            name="bannerAltText"
                            className="w-100"
                            placeholder="Enter descriptive text for the banner"
                            value={universityData.bannerImage?.alt || ""}
                            onChange={e => {
                              setUniversityData({
                                ...universityData,
                                bannerImage: {
                                  url: bannerUrl,
                                  alt: e.target.value,
                                },
                              })
                            }}
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>

                <div className="university-add-inp">
                  <label htmlFor="gallery">
                    Gallery Images <small className="text-danger"> *</small>
                  </label>
                  <div className="inp-err">
                    {galleryUrls.length > 0 && (
                      <div className="gallery-preview mb-3">
                        <div className="d-flex flex-wrap gap-2">
                          {galleryUrls.map((url, index) => (
                            <div
                              key={index}
                              className="position-relative"
                              style={{ width: "200px" }}
                            >
                              <img
                                src={url}
                                alt={`Gallery ${index + 1}`}
                                style={{
                                  width: "100%",
                                  height: "150px",
                                  objectFit: "cover",
                                  border: "1px solid #ddd",
                                  borderRadius: "4px",
                                }}
                              />
                              <Button
                                type="button"
                                color="danger"
                                size="sm"
                                className="position-absolute top-0 end-0"
                                style={{ margin: "2px" }}
                                onClick={() => removeGalleryImage(index)}
                              >
                                ×
                              </Button>
                              <div className="mt-2">
                                <InputText
                                  placeholder="Enter alt text for this image"
                                  value={galleryAltTexts[index] || ""}
                                  onChange={e =>
                                    handleGalleryAltTextChange(
                                      index,
                                      e.target.value,
                                    )
                                  }
                                  className="w-100"
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {galleryFiles.length > 0 && (
                      <div className="selected-files mb-2">
                        <h6>Selected Files:</h6>
                        {galleryFiles.map((file, index) => (
                          <div
                            key={index}
                            className="d-flex justify-content-between align-items-center mb-1"
                          >
                            <small>{file.name}</small>
                            <Button
                              type="button"
                              color="danger"
                              size="sm"
                              onClick={() => removeSelectedFile(index)}
                            >
                              Remove
                            </Button>
                          </div>
                        ))}
                      </div>
                    )}

                    <div className="d-flex align-items-center gap-2">
                      <input
                        type="file"
                        name="gallery"
                        id="gallery"
                        accept="image/*"
                        multiple
                        onChange={handleGalleryChange}
                      />
                      {galleryFiles.length > 0 && !isUploadingGallery && (
                        <Button
                          type="button"
                          color="primary"
                          size="sm"
                          onClick={uploadGalleryImages}
                        >
                          Upload Selected
                        </Button>
                      )}
                    </div>
                    {isUploadingGallery && (
                      <small className="d-block mt-1">
                        <Spinner size="sm" /> Uploading gallery images...
                      </small>
                    )}
                  </div>
                </div>
              </div>

              <div className="save-cancel-btn mt-4 d-flex align-items-center justify-content-end gap-3">
                <Button
                  type="button"
                  outline
                  color="danger"
                  className="waves-effect waves-light"
                  onClick={() => {
                    navigate(-1)
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  color="secondary"
                  className="waves-effect waves-light"
                  disabled={loading}
                  onClick={() => {
                    addUniversity()
                  }}
                >
                  {loading ? <Spinner size="sm" /> : "Add"}
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default AddUniversity
